import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { ChiTietPhieuNhapKho, PhieuNhapKho } from '../phieu-nhap-kho-ver2-model/phieu-nhap-kho-ver2.model';
const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class NhapKhoVer2Service {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/PhieuNhapKho_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getChiTiet(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Get_Detail`;
		return this.http.post<any>(url,item, { headers: httpHeaders });
	}
	getDSVTK(IdKho: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/dungchung' + `/ViTriKho_List?IdKho=${IdKho}` ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	getListGhiChu(Id: number[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/kho' + `/TTHV_Get_GhiChu` ;
		return this.http.post<any>(url, Id, { headers: httpHeaders });
	}
	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/PhieuNhapKho_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/NKTemplateImport`;
	}
	/*---------------------------------------------------------------------- */
	

	/*-------------------------------POST Method---------------------------- */
	add(item: PhieuNhapKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Insert', item, { headers: httpHeaders });
	}
	addDetail(item:ChiTietPhieuNhapKho): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ChiTietPhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Insert_Detail', item, { headers: httpHeaders });
	}
	updateWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_With_Detail', item, { headers: httpHeaders });
	}
	updateHHState(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_StateHH', item, { headers: httpHeaders });
	}
	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Delete?IdNk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	checkCancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Check_Cancel?IdNk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Cancel?IdNk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	updateOnly(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_Only', item, { headers: httpHeaders });
	}
	duyet(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_StateConfirm', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */
	
}
